import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Label,
  Input,
  FormGroup,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage, useIntl } from "react-intl";

const CreateAPLPeriodDocuments = ({
  aplDocumentsWithUsers,
  setAplDocumentsWithUsers,
  aplStudentSupervisors,
  isModifying,
}) => {
  const intl = useIntl();
  const [selectableUsers, setSelectableUsers] = useState([]);

  useEffect(() => {
    let UsersForSelect = [];

    aplStudentSupervisors.forEach((stud) => {
      let studentForSelect = {
        userType: "Student",
        value: isModifying ? stud.student : stud,
        label: isModifying ? stud.student.name : stud.name,
      };
      UsersForSelect.push(studentForSelect);
      stud.supervisors.forEach((sv) => {
        let supervisorForSelect = {
          userType: "AplSupervisor",
          value: isModifying ? sv.supervisor : sv,
          label: isModifying ? sv.supervisor.name : sv.name,
        };
        if (
          !UsersForSelect.some(
            (sv) => sv.value.id === supervisorForSelect.value.id
          )
        ) {
          UsersForSelect.push(supervisorForSelect);
        }
      });
    });
    setSelectableUsers(UsersForSelect);
  }, [aplDocumentsWithUsers, aplStudentSupervisors, isModifying]);

  const handleFile = (event) => {
    let newDocument = {
      document: event.files[0],
      users: [],
    };
    setAplDocumentsWithUsers([...aplDocumentsWithUsers, newDocument]);
  };

  const handleRemoveDocument = (item) => {
    setAplDocumentsWithUsers(
      aplDocumentsWithUsers.filter((doc) => doc.document !== item.document)
    );
  };

  const handleAddAndRemoveDocumentsForUser = (users, documentUserList) => {
    let currentDocumentIndex = aplDocumentsWithUsers.findIndex(
      (sv) => sv.document === documentUserList.document
    );
    let tempAplDocumentsWithUsers = aplDocumentsWithUsers;

    if (users.some((user) => user.value === "AllStudents")) {
      users = users.filter((item) => item.userType !== "Student");
      users = users.filter((item) => item.value !== "AllStudents");
      aplStudentSupervisors.forEach((stud) => {
        let studentForSelect = {
          userType: "Student",
          value: stud,
          label: stud.name,
        };
        if (!users.some((usr) => usr.value.id === studentForSelect.value.id)) {
          users.push(studentForSelect);
        }
      });
    }
    if (users.some((user) => user.value === "AllSupervisors")) {
      users = users.filter((item) => item.userType !== "AplSupervisor");
      users = users.filter((item) => item.value !== "AllSupervisors");
      aplStudentSupervisors.forEach((stud) => {
        stud.supervisors.forEach((sv) => {
          let supervisorForSelect = {
            userType: "AplSupervisor",
            value: isModifying ? sv.supervisor : sv,
            label: isModifying ? sv.supervisor.name : sv.name,
          };
          if (
            !users.some((usr) => usr.value.id === supervisorForSelect.value.id)
          ) {
            users.push(supervisorForSelect);
          }
        });
      });
    }

    tempAplDocumentsWithUsers[currentDocumentIndex].users = users;
    setAplDocumentsWithUsers(tempAplDocumentsWithUsers);
  };

  const DocumentsAndUsers = ({ intl }) => {
    const setFileName = (value, item) => {
      item.description = value;
    };
    if (aplDocumentsWithUsers.length > 0) {
      return aplDocumentsWithUsers.map((item, key) => {
        var selectableStudents = [];
        var selectableSupervisors = [];
        item.description = item.description
          ? item.description
          : item.document.name;
        selectableUsers.forEach((user) => {
          if (
            item.users.findIndex((forUser) => {
              return forUser.value
                ? forUser.value.id === user.value.id
                : forUser.id === user.value.id;
            }) < 0
          ) {
            if (user.userType === "Student") {
              selectableStudents.push(user);
            } else if (user.userType === "AplSupervisor") {
              selectableSupervisors.push(user);
            }
          }
        });

        if (selectableStudents.length > 1) {
          let AddAllStudents = {
            value: "AllStudents",
            userType: "SelectAllStudents",
            label: intl.formatMessage({
              id: "SelectAllStudentsInPeriod",
            }),
          };
          selectableStudents.unshift(AddAllStudents);
        }

        if (selectableSupervisors.length > 1) {
          let AddAllSupervisors = {
            value: "AllSupervisors",
            userType: "SelectAllSupervisors",
            label: intl.formatMessage({
              id: "SelectAllSupervisorsInPeriod",
            }),
          };
          selectableSupervisors.unshift(AddAllSupervisors);
        }

        const groupedOptions = [
          {
            label: "Elever",
            options: selectableStudents,
          },
          {
            label: "Handledare",
            options: selectableSupervisors,
          },
        ];

        return (
          <Card key={key} className="mt-4 mb-0">
            <CardHeader>
              <FontAwesomeIcon
                icon="circle-xmark"
                size="1x"
                className="me-3 text-secondary"
                style={{ cursor: "pointer" }}
                onClick={() => handleRemoveDocument(item)}
              />
              <Input
                style={{ display: "inline-block", width: "inherit" }}
                type="text"
                name="name"
                id="nameForFile"
                defaultValue={item.description}
                onChange={(value) => setFileName(value.target.value, item)}
              />
            </CardHeader>

            <Select
              menuPortalTarget={document.body}
              menuPosition={"fixed"}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              name="students"
              placeholder={intl.formatMessage({
                id: "ChoosePersonsThatShouldHaveAccessToDocument",
              })}
              defaultValue={item.users}
              isMulti
              options={groupedOptions}
              onChange={(event) =>
                handleAddAndRemoveDocumentsForUser(event, item)
              }
              noOptionsMessage={({ inputValue }) => (
                <FormattedMessage id="NoPersonsInPeriodGoBackAndAdd" />
              )}
            />
          </Card>
        );
      });
    }
    return null;
  };

  return (
    <>
      <Card>
        <CardBody>
          <CardTitle>
            <FormattedMessage id="UploadDocument" /> <hr />
          </CardTitle>

          <FormGroup>
            <Label for="exampleFile">
              <FormattedMessage id="Documents" />
            </Label>

            <Input
              type="file"
              name="file"
              id="exampleFile"
              onChange={(val) => handleFile(val.target)}
            />
          </FormGroup>
        </CardBody>
      </Card>

      <DocumentsAndUsers intl={intl} />
    </>
  );
};
export default CreateAPLPeriodDocuments;
